import { DesignStudioGlobalStylesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The `design-studio_` (trailing underscore) segment keeps this route OUT of
// the `design-studio.tsx` layout route, which renders only the not-found fallback
// without an Outlet — a nested child's component would never
// render. As a static path, `/design-studio/global-styles` outranks the
// `/design-studio/$` splat, so this route wins the match for the global-styles
// URL.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/design-studio_/global-styles')({
  component: DesignStudioGlobalStylesRoute,
});
